import React, { useState, useContext } from 'react';
import { KFLButton } from '@kamstrup/kamstrup-frontend-library';
import { connect } from 'react-redux';
import * as Devices from '../../../modules/devices';
import ModalDialog from '../modalDialog';
import ColumnSetting from './columnSetting';
import * as DT from '../../../modules/datatable';
import { ReduxState } from '../../../interfaces';
import { setModal } from '../../../modules/dialogs/actions';
import './settingsDialog.scss';
import { AppKeys } from '../../../core/localization';
import Translate from '../localization/localize';
import { LocaleCtx } from '../../../contexts/locale.context';

interface StateProps {
  columns: DT.TableColumn[];
  fnHideDialog: () => void;
  fnUpdateBtnClicked: (columns: DT.TableColumn[]) => void;
}
type Props = StateProps;

const SettingsDialog: React.FC<Props> = (props) => {
  const [columns, setColumns] = useState(props.columns);

  const { translate } = useContext(LocaleCtx);

  const toggleColumn = (column: DT.TableColumn) =>
    setColumns(DT.updateColumnVisibility(columns, column));

  const columnHeader = (
    <div className="section__header">
      {translate(AppKeys.TableSetting_Section_Columns)}
    </div>
  );

  let i = 0;
  const columnsSection = (
    <div key="settings-columns">
      {columns.map((o) => (
        <ColumnSetting
          key={`column-${i++}`}
          column={o}
          toggleColumn={toggleColumn}
        />
      ))}
    </div>
  );

  const updateBtn = (
    <KFLButton
      key="md-settings-update"
      variant="primary"
      onClick={() => {
        props.fnUpdateBtnClicked(columns);
        props.fnHideDialog();
      }}
    >
      <Translate message={AppKeys.Btn_Apply} />
    </KFLButton>
  );

  return (
    <ModalDialog
      title={translate(AppKeys.TableSetting_Title)}
      classes="modal_Settings"
      body={[columnHeader, columnsSection]}
      onClose={props.fnHideDialog}
      footerBtns={[updateBtn]}
      footerCancel
    />
  );
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  columns: state.devicesState.table.columns,
  fnHideDialog: () => setModal(''),
  fnUpdateBtnClicked: Devices.updateColumns,
});

export default connect(mapStateToProps)(SettingsDialog);
